import { render } from "./AsyncLoader.vue?vue&type=template&id=26027732&scoped=true"
import script from "./AsyncLoader.vue?vue&type=script&lang=js"
export * from "./AsyncLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26027732"]])

export default __exports__